module.exports = __webpack_public_path__ + "img/choose2.1226fd93.png";